import ResourceService from "@/services/resource/resource.service";

export const resource = {
    namespaced: true,
    state:{list:[]},
    actions:{
        getResource({ commit }){
            return ResourceService.getResourceList()
                .then(
                    resource => {
                        commit('resourceListFetchSuccess', resource)
                    },
                    error => {
                        commit('resourceListFetchFail',error)
                    }
                )
        },

    },
    mutations: {
        resourceListFetchSuccess(state, request){
            state.list = request.data.resource
        },
        resourceListFetchFail(state, error){
            state.error = error
        }
    }

}